import type { MiscTaskTypeId } from '../services/api/types.gen';
import { MISCTASKTYPEID_VALUES } from '../services/api/models/MiscTaskTypeId';

/**
 * All misc task type values, in Add Task picker order. Derived from the
 * generated enum values so a new backend member cannot be silently missing from
 * the picker.
 */
export const MISC_TASK_TYPES: readonly MiscTaskTypeId[] = MISCTASKTYPEID_VALUES;
